import { render, staticRenderFns } from "./purchaseProduct.vue?vue&type=template&id=63224586&"
import script from "./purchaseProduct.vue?vue&type=script&lang=js&"
export * from "./purchaseProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports